import { TextInput, Toggle, Select, ColorPicker } from '../admin/components/ui';

export const renderInputRow = (
    label,
    key,
    type = 'text',
    options = [],
    hint = '',
    Settings = {},
    updateSetting = () => {},
    disabled = false
) => {
    const isToggle = type === 'checkBox';

    return (
        <div key={key} className={`dss-field-row${isToggle ? ' dss-field-row--toggle' : ''}`}>
            <div className="dss-field-label">{label}{disabled && <span className="pqd-pro-badge"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M3 7l4 4 5-7 5 7 4-4-2 13H5L3 7z"/></svg>PRO</span>}</div>
            <div className="dss-field-control">
    <div className="dss-field-input-wrap">
        {isToggle ? (
            <Toggle
                checked={Settings[key] === 'on'}
                onChange={val => updateSetting(key, val ? 'on' : 'no')}
                disabled={disabled}
            />
        ) : type === 'select' ? (
            <Select
                value={Settings[key]}
                options={options}
                onChange={val => updateSetting(key, val)}
                disabled={disabled}
            />
        ) : type === 'colorPallete' ? (
            <ColorPicker
                value={Settings[key]}
                onChange={val => updateSetting(key, val)}
                disabled={disabled}
            />
        ) : (
            <TextInput
                type={type || 'text'}
                value={Settings[key] || ''}
                onChange={val => updateSetting(key, val)}
                disabled={disabled}
            />
        )}

        {/* PRO MESSAGE BESIDE FIELD */}
        {disabled && (
            <span className="dss-pro-message">
                Available in
                <a
                    href="https://www.plugin999.com/plugin/display-stock-status-for-woocommerce/"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                >
                    Pro Version
                </a>
            </span>
        )}
    </div>

    {/* HINT ALWAYS BELOW */}
    {hint && (
        <div className="dss-field-hint">
            <em>{hint}</em>
        </div>
    )}
</div>
        </div>
    );
};
